import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const Floor9Component = ({unitStatus}) => {
  console.log('unitStatus', unitStatus);
    useEffect(() => {
        // Initialize ImageMapPro after the component mounts
        const initializeImageMap = () => {
            if (window.ImageMapPro) {
              window.ImageMapPro.init('#image-map-pro', {
    "id": "4ef7385f-0281-44f2-bd9d-58909abfaa3c",
    "general": {
      "name": "Floor 9, 11"
    },
    "artboards": [
      {
        "background_type": "image",
        "image_url": "https://greendirectorydata.s3.us-east-2.amazonaws.com/GPP8KP49th%2C11thFLOORcopy.png",
        "width": 3810,
        "height": 2351,
        "use_image_size": true,
        "children": [
          {
            "id": "ba2d29c0-af5b-422f-a9bf-8ec3759bb0fb",
            "title": "Poly",
            "type": "poly",
            "x": 48.92086330935252,
            "y": 4.06490252024242,
            "width": 17.841726618705046,
            "height": 49.90008843626927,
            "default_style": {
              "background_opacity": 0
            },
            "mouseover_style": {
              "background_color": "#0e2b33",
              "background_opacity": 1
            },
            "tooltip_style": {
              "background_color": "#0b2e33"
            },
            "tooltip_content": [
              {
                "type": "Heading",
                "text": "Designer Suit - 07",
                "heading": "h3",
                "other": {
                  "id": "",
                  "classes": "",
                  "css": ""
                },
                "style": {
                  "fontFamily": "italiana",
                  "fontSize": 20.8,
                  "lineHeight": "normal",
                  "color": "#ffffff",
                  "textAlign": "left"
                },
                "boxModel": {
                  "width": "auto",
                  "height": "auto",
                  "margin": {
                    "top": 0,
                    "bottom": 0,
                    "left": 0,
                    "right": 0
                  },
                  "padding": {
                    "top": 10,
                    "bottom": 10,
                    "left": 10,
                    "right": 10
                  }
                },
                "id": "b7b199c4-c84c-429c-b472-a5b8898b197b"
              },
              {
                "type": "Paragraph",
                "text": unitStatus && unitStatus[6].status.toUpperCase(),
                "other": {
                  "id": "",
                  "classes": "",
                  "css": ""
                },
                "style": {
                  "fontFamily": "barlow",
                  "fontSize": 26,
                  "lineHeight": 22,
                  "color": "#ad937b",
                  "textAlign": "left"
                },
                "boxModel": {
                  "width": "auto",
                  "height": "auto",
                  "margin": {
                    "top": 0,
                    "bottom": 0,
                    "left": 0,
                    "right": 0
                  },
                  "padding": {
                    "top": 10,
                    "bottom": 10,
                    "left": 10,
                    "right": 10
                  }
                },
                "id": "3d742eba-c724-4b34-bcd3-971a4b825f63"
              }
            ],
            "actions": {
              "click": unitStatus && unitStatus[6].status === 'available' ? "run-script" : "none",
              "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/9/7';"
            },
            "x_image_background": 48.92086330935252,
            "y_image_background": 4.06490252024242,
            "points": [
              {
                "x": 100,
                "y": 0.23364485981308408
              },
              {
                "x": 0,
                "y": 0
              },
              {
                "x": 0.4032258064516129,
                "y": 21.49532710280374
              },
              {
                "x": 42.74193548387097,
                "y": 21.962616822429908
              },
              {
                "x": 42.33870967741936,
                "y": 94.62616822429906
              },
              {
                "x": 51.20967741935484,
                "y": 94.85981308411215
              },
              {
                "x": 52.016129032258064,
                "y": 99.53271028037383
              },
              {
                "x": 69.75806451612904,
                "y": 100
              },
              {
                "x": 69.75806451612904,
                "y": 94.62616822429906
              },
              {
                "x": 100,
                "y": 94.62616822429906
              }
            ]
          },
          {
            "id": "da6a149b-e009-4e85-92ed-3243a9685951",
            "title": "Poly",
            "type": "poly",
            "x": 66.61870503597123,
            "y": 3.831724536895367,
            "width": 32.23021582733813,
            "height": 50.13326641961633,
            "default_style": {
              "background_opacity": 0
            },
            "mouseover_style": {
              "background_color": "#0e2b33",
              "background_opacity": 1
            },
            "tooltip_style": {
              "background_color": "#0b2e33"
            },
            "tooltip_content": [
              {
                "type": "Heading",
                "text": "Designer Suit - 06",
                "heading": "h3",
                "other": {
                  "id": "",
                  "classes": "",
                  "css": ""
                },
                "style": {
                  "fontFamily": "italiana",
                  "fontSize": 20.8,
                  "lineHeight": "normal",
                  "color": "#ffffff",
                  "textAlign": "left"
                },
                "boxModel": {
                  "width": "auto",
                  "height": "auto",
                  "margin": {
                    "top": 0,
                    "bottom": 0,
                    "left": 0,
                    "right": 0
                  },
                  "padding": {
                    "top": 10,
                    "bottom": 10,
                    "left": 10,
                    "right": 10
                  }
                },
                "id": "b7b199c4-c84c-429c-b472-a5b8898b197b"
              },
              {
                "type": "Paragraph",
                "text": unitStatus && unitStatus[5].status.toUpperCase(),
                "other": {
                  "id": "",
                  "classes": "",
                  "css": ""
                },
                "style": {
                  "fontFamily": "barlow",
                  "fontSize": 26,
                  "lineHeight": 22,
                  "color": "#ad937b",
                  "textAlign": "left"
                },
                "boxModel": {
                  "width": "auto",
                  "height": "auto",
                  "margin": {
                    "top": 0,
                    "bottom": 0,
                    "left": 0,
                    "right": 0
                  },
                  "padding": {
                    "top": 10,
                    "bottom": 10,
                    "left": 10,
                    "right": 10
                  }
                },
                "id": "3d742eba-c724-4b34-bcd3-971a4b825f63"
              }
            ],
            "actions": {
              "click": unitStatus && unitStatus[5].status === 'available' ? "run-script" : "none",
              "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/9/6';"
            },
            "x_image_background": 66.61870503597123,
            "y_image_background": 3.831724536895367,
            "points": [
              {
                "x": 100,
                "y": 36.74418604651163
              },
              {
                "x": 100,
                "y": 0.46511627906976744
              },
              {
                "x": 0,
                "y": 0
              },
              {
                "x": 0.4464285714285714,
                "y": 94.41860465116278
              },
              {
                "x": 16.964285714285715,
                "y": 94.65116279069767
              },
              {
                "x": 16.741071428571427,
                "y": 99.76744186046511
              },
              {
                "x": 27.232142857142854,
                "y": 100
              },
              {
                "x": 27.232142857142854,
                "y": 94.65116279069767
              },
              {
                "x": 31.919642857142854,
                "y": 94.65116279069767
              },
              {
                "x": 32.142857142857146,
                "y": 36.97674418604651
              }
            ]
          },
          {
            "id": "82820315-c7ec-4cbb-94ef-831eeee65f1e",
            "title": "Poly",
            "type": "poly",
            "x": 65.82733812949641,
            "y": 61.89304239031149,
            "width": 32.80575539568345,
            "height": 36.142587418793156,
            "default_style": {
              "background_opacity": 0
            },
            "mouseover_style": {
              "background_color": "#0e2b33",
              "background_opacity": 1
            },
            "tooltip_style": {
              "background_color": "#0b2e33"
            },
            "tooltip_content": [
              {
                "type": "Heading",
                "text": "Two Bedroom Penthouse - 05",
                "heading": "h3",
                "other": {
                  "id": "",
                  "classes": "",
                  "css": ""
                },
                "style": {
                  "fontFamily": "italiana",
                  "fontSize": 20.8,
                  "lineHeight": "normal",
                  "color": "#ffffff",
                  "textAlign": "left"
                },
                "boxModel": {
                  "width": "auto",
                  "height": "auto",
                  "margin": {
                    "top": 0,
                    "bottom": 0,
                    "left": 0,
                    "right": 0
                  },
                  "padding": {
                    "top": 10,
                    "bottom": 10,
                    "left": 10,
                    "right": 10
                  }
                },
                "id": "b7b199c4-c84c-429c-b472-a5b8898b197b"
              },
              {
                "type": "Paragraph",
                "text": unitStatus && unitStatus[4].status.toUpperCase(),
                "other": {
                  "id": "",
                  "classes": "",
                  "css": ""
                },
                "style": {
                  "fontFamily": "barlow",
                  "fontSize": 26,
                  "lineHeight": 22,
                  "color": "#ad937b",
                  "textAlign": "left"
                },
                "boxModel": {
                  "width": "auto",
                  "height": "auto",
                  "margin": {
                    "top": 0,
                    "bottom": 0,
                    "left": 0,
                    "right": 0
                  },
                  "padding": {
                    "top": 10,
                    "bottom": 10,
                    "left": 10,
                    "right": 10
                  }
                },
                "id": "3d742eba-c724-4b34-bcd3-971a4b825f63"
              }
            ],
            "actions": {
              "click": unitStatus && unitStatus[4].status === 'available' ? "run-script" : "none",
              "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/9/5';"
            },
            "x_image_background": 65.82733812949641,
            "y_image_background": 61.89304239031149,
            "points": [
              {
                "x": 0.21929824561403508,
                "y": 0
              },
              {
                "x": 0,
                "y": 80
              },
              {
                "x": 12.5,
                "y": 79.6774193548387
              },
              {
                "x": 12.719298245614036,
                "y": 99.35483870967742
              },
              {
                "x": 50.877192982456144,
                "y": 99.35483870967742
              },
              {
                "x": 50.877192982456144,
                "y": 80
              },
              {
                "x": 64.69298245614034,
                "y": 79.6774193548387
              },
              {
                "x": 64.47368421052632,
                "y": 100
              },
              {
                "x": 83.33333333333334,
                "y": 99.67741935483872
              },
              {
                "x": 83.1140350877193,
                "y": 80
              },
              {
                "x": 95.83333333333334,
                "y": 79.6774193548387
              },
              {
                "x": 95.17543859649122,
                "y": 33.87096774193548
              },
              {
                "x": 100,
                "y": 33.87096774193548
              },
              {
                "x": 100,
                "y": 0
              }
            ]
          },
          {
            "id": "ab239491-320d-47e7-828d-35fa88a4e06f",
            "title": "Poly",
            "type": "poly",
            "x": 34.82014388489208,
            "y": 62.00963138198502,
            "width": 31.007194244604328,
            "height": 36.02599842711963,
            "default_style": {
              "background_opacity": 0
            },
            "mouseover_style": {
              "background_color": "#0e2b33",
              "background_opacity": 1
            },
            "tooltip_style": {
              "background_color": "#0b2e33"
            },
            "tooltip_content": [
              {
                "type": "Heading",
                "text": "Two Bedroom Penthouse - 04",
                "heading": "h3",
                "other": {
                  "id": "",
                  "classes": "",
                  "css": ""
                },
                "style": {
                  "fontFamily": "italiana",
                  "fontSize": 20.8,
                  "lineHeight": "normal",
                  "color": "#ffffff",
                  "textAlign": "left"
                },
                "boxModel": {
                  "width": "auto",
                  "height": "auto",
                  "margin": {
                    "top": 0,
                    "bottom": 0,
                    "left": 0,
                    "right": 0
                  },
                  "padding": {
                    "top": 10,
                    "bottom": 10,
                    "left": 10,
                    "right": 10
                  }
                },
                "id": "b7b199c4-c84c-429c-b472-a5b8898b197b"
              },
              {
                "type": "Paragraph",
                "text": unitStatus && unitStatus[3].status.toUpperCase(),
                "other": {
                  "id": "",
                  "classes": "",
                  "css": ""
                },
                "style": {
                  "fontFamily": "barlow",
                  "fontSize": 26,
                  "lineHeight": 22,
                  "color": "#ad937b",
                  "textAlign": "left"
                },
                "boxModel": {
                  "width": "auto",
                  "height": "auto",
                  "margin": {
                    "top": 0,
                    "bottom": 0,
                    "left": 0,
                    "right": 0
                  },
                  "padding": {
                    "top": 10,
                    "bottom": 10,
                    "left": 10,
                    "right": 10
                  }
                },
                "id": "3d742eba-c724-4b34-bcd3-971a4b825f63"
              }
            ],
            "actions": {
              "click": unitStatus && unitStatus[3].status === 'available' ? "run-script" : "none",
              "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/9/4';"
            },
            "x_image_background": 34.82014388489208,
            "y_image_background": 62.00963138198502,
            "points": [
              {
                "x": 0,
                "y": 0
              },
              {
                "x": 0.23201856148491878,
                "y": 99.67637540453075
              },
              {
                "x": 20.649651972157773,
                "y": 99.67637540453075
              },
              {
                "x": 20.417633410672853,
                "y": 79.28802588996764
              },
              {
                "x": 46.8677494199536,
                "y": 79.6116504854369
              },
              {
                "x": 46.635730858468676,
                "y": 100
              },
              {
                "x": 86.77494199535964,
                "y": 99.67637540453075
              },
              {
                "x": 87.00696055684455,
                "y": 79.6116504854369
              },
              {
                "x": 100,
                "y": 79.28802588996764
              },
              {
                "x": 100,
                "y": 0
              }
            ]
          },
          {
            "id": "9f614909-4717-49dc-9b5a-7aa34c734619",
            "title": "Poly",
            "type": "poly",
            "x": 3.597122302158273,
            "y": 61.89304239031149,
            "width": 31.294964028776977,
            "height": 36.142587418793156,
            "default_style": {
              "background_opacity": 0
            },
            "mouseover_style": {
              "background_color": "#0e2b33",
              "background_opacity": 1
            },
            "tooltip_style": {
              "background_color": "#0b2e33"
            },
            "tooltip_content": [
              {
                "type": "Heading",
                "text": "Two Bedroom Penthouse - 03",
                "heading": "h3",
                "other": {
                  "id": "",
                  "classes": "",
                  "css": ""
                },
                "style": {
                  "fontFamily": "italiana",
                  "fontSize": 20.8,
                  "lineHeight": "normal",
                  "color": "#ffffff",
                  "textAlign": "left"
                },
                "boxModel": {
                  "width": "auto",
                  "height": "auto",
                  "margin": {
                    "top": 0,
                    "bottom": 0,
                    "left": 0,
                    "right": 0
                  },
                  "padding": {
                    "top": 10,
                    "bottom": 10,
                    "left": 10,
                    "right": 10
                  }
                },
                "id": "b7b199c4-c84c-429c-b472-a5b8898b197b"
              },
              {
                "type": "Paragraph",
                "text": unitStatus && unitStatus[2].status.toUpperCase(),
                "other": {
                  "id": "",
                  "classes": "",
                  "css": ""
                },
                "style": {
                  "fontFamily": "barlow",
                  "fontSize": 26,
                  "lineHeight": 22,
                  "color": "#ad937b",
                  "textAlign": "left"
                },
                "boxModel": {
                  "width": "auto",
                  "height": "auto",
                  "margin": {
                    "top": 0,
                    "bottom": 0,
                    "left": 0,
                    "right": 0
                  },
                  "padding": {
                    "top": 10,
                    "bottom": 10,
                    "left": 10,
                    "right": 10
                  }
                },
                "id": "3d742eba-c724-4b34-bcd3-971a4b825f63"
              }
            ],
            "actions": {
              "click": unitStatus && unitStatus[2].status === 'available' ? "run-script" : "none",
              "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/9/3';"
            },
            "x_image_background": 3.597122302158273,
            "y_image_background": 61.89304239031149,
            "points": [
              {
                "x": 0.9195402298850575,
                "y": 0.3225806451612903
              },
              {
                "x": 0,
                "y": 80
              },
              {
                "x": 13.10344827586207,
                "y": 80
              },
              {
                "x": 12.873563218390805,
                "y": 100
              },
              {
                "x": 54.02298850574713,
                "y": 99.35483870967742
              },
              {
                "x": 54.252873563218394,
                "y": 79.35483870967742
              },
              {
                "x": 79.77011494252874,
                "y": 79.35483870967742
              },
              {
                "x": 80.22988505747126,
                "y": 99.35483870967742
              },
              {
                "x": 100,
                "y": 99.67741935483872
              },
              {
                "x": 99.77011494252874,
                "y": 0
              }
            ]
          },
          {
            "id": "99596483-be74-43a3-bac4-1cdb8405baf4",
            "title": "Poly",
            "type": "poly",
            "x": 3.9568345323741005,
            "y": 3.8317233362633907,
            "width": 19.71223021582734,
            "height": 50.13326641961633,
            "default_style": {
              "background_opacity": 0
            },
            "mouseover_style": {
              "background_color": "#032b33",
              "background_opacity": 1
            },
            "tooltip_style": {
              "background_color": "#0b2e33"
            },
            "tooltip_content": [
              {
                "type": "Heading",
                "text": "Designer Suit - 02",
                "heading": "h3",
                "other": {
                  "id": "",
                  "classes": "",
                  "css": ""
                },
                "style": {
                  "fontFamily": "italiana",
                  "fontSize": 20.8,
                  "lineHeight": "normal",
                  "color": "#ffffff",
                  "textAlign": "left"
                },
                "boxModel": {
                  "width": "auto",
                  "height": "auto",
                  "margin": {
                    "top": 0,
                    "bottom": 0,
                    "left": 0,
                    "right": 0
                  },
                  "padding": {
                    "top": 10,
                    "bottom": 10,
                    "left": 10,
                    "right": 10
                  }
                },
                "id": "b7b199c4-c84c-429c-b472-a5b8898b197b"
              },
              {
                "type": "Paragraph",
                "text": unitStatus && unitStatus[1].status.toUpperCase(),
                "other": {
                  "id": "",
                  "classes": "",
                  "css": ""
                },
                "style": {
                  "fontFamily": "barlow",
                  "fontSize": 26,
                  "lineHeight": 22,
                  "color": "#ad937b",
                  "textAlign": "left"
                },
                "boxModel": {
                  "width": "auto",
                  "height": "auto",
                  "margin": {
                    "top": 0,
                    "bottom": 0,
                    "left": 0,
                    "right": 0
                  },
                  "padding": {
                    "top": 10,
                    "bottom": 10,
                    "left": 10,
                    "right": 10
                  }
                },
                "id": "3d742eba-c724-4b34-bcd3-971a4b825f63"
              }
            ],
            "actions": {
              "click": unitStatus && unitStatus[1].status === 'available' ? "run-script" : "none",
              "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/9/2';"
            },
            "x_image_background": 3.9568345323741005,
            "y_image_background": 3.9483135285688933,
            "points": [
              {
                "x": 99.63503649635037,
                "y": 0
              },
              {
                "x": 0,
                "y": 0
              },
              {
                "x": 0,
                "y": 27.44186046511628
              },
              {
                "x": 47.81021897810219,
                "y": 27.44186046511628
              },
              {
                "x": 48.54014598540146,
                "y": 93.95348837209302
              },
              {
                "x": 55.839416058394164,
                "y": 94.41860465116278
              },
              {
                "x": 55.839416058394164,
                "y": 100
              },
              {
                "x": 72.26277372262774,
                "y": 99.53488372093024
              },
              {
                "x": 72.26277372262774,
                "y": 94.41860465116278
              },
              {
                "x": 100,
                "y": 94.65116279069767
              }
            ]
          },
          {
            "id": "19c01405-2eb7-42e5-bd77-a4a440e356fe",
            "title": "Poly",
            "type": "poly",
            "x": 23.597122302158276,
            "y": 3.7151343445898646,
            "width": 17.985611510791365,
            "height": 50.0166774279428,
            "default_style": {
              "background_opacity": 0
            },
            "mouseover_style": {
              "background_color": "#0e2b33",
              "background_opacity": 1
            },
            "tooltip_style": {
              "background_color": "#0b2e33"
            },
            "tooltip_content": [
              {
                "type": "Heading",
                "text": "Designer Suit - 01",
                "heading": "h3",
                "other": {
                  "id": "",
                  "classes": "",
                  "css": ""
                },
                "style": {
                  "fontFamily": "italiana",
                  "fontSize": 20.8,
                  "lineHeight": "normal",
                  "color": "#ffffff",
                  "textAlign": "left"
                },
                "boxModel": {
                  "width": "auto",
                  "height": "auto",
                  "margin": {
                    "top": 0,
                    "bottom": 0,
                    "left": 0,
                    "right": 0
                  },
                  "padding": {
                    "top": 10,
                    "bottom": 10,
                    "left": 10,
                    "right": 10
                  }
                },
                "id": "b7b199c4-c84c-429c-b472-a5b8898b197b"
              },
              {
                "type": "Paragraph",
                "text": unitStatus && unitStatus[0].status.toUpperCase(),
                "other": {
                  "id": "",
                  "classes": "",
                  "css": ""
                },
                "style": {
                  "fontFamily": "barlow",
                  "fontSize": 26,
                  "lineHeight": 22,
                  "color": "#ad937b",
                  "textAlign": "left"
                },
                "boxModel": {
                  "width": "auto",
                  "height": "auto",
                  "margin": {
                    "top": 0,
                    "bottom": 0,
                    "left": 0,
                    "right": 0
                  },
                  "padding": {
                    "top": 10,
                    "bottom": 10,
                    "left": 10,
                    "right": 10
                  }
                },
                "id": "3d742eba-c724-4b34-bcd3-971a4b825f63"
              }
            ],
            "actions": {
              "click": unitStatus && unitStatus[0].status === 'available' ? "run-script" : "none",
              "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/9/1';"
            },
            "x_image_background": 23.597122302158276,
            "y_image_background": 3.831724536895367,
            "points": [
              {
                "x": 99.2,
                "y": 21.678321678321677
              },
              {
                "x": 100,
                "y": 0
              },
              {
                "x": 0,
                "y": 0.2331002331002331
              },
              {
                "x": 0.4,
                "y": 94.87179487179486
              },
              {
                "x": 30,
                "y": 94.87179487179486
              },
              {
                "x": 30,
                "y": 100
              },
              {
                "x": 48.4,
                "y": 100
              },
              {
                "x": 47.599999999999994,
                "y": 94.63869463869464
              },
              {
                "x": 57.199999999999996,
                "y": 94.87179487179486
              },
              {
                "x": 56.8,
                "y": 21.91142191142191
              }
            ]
          }
        ]
      }
    ],
    "version": "6.0.20"
  }
)
                // window.ImageMapPro.init('#image-map-pro', {
                //   "id": "4ef7385f-0281-44f2-bd9d-58909abfaa3c",
                //   "general": {
                //     "name": "Floor 9, 11"
                //   },
                //   "artboards": [
                //     {
                //       "background_type": "image",
                //       "image_url": "https://greendirectorydata.s3.us-east-2.amazonaws.com/GPP8KP49th%2C11thFLOORcopy.png",
                //       "width": 3810,
                //       "height": 2351,
                //       "use_image_size": true,
                //       "children": [
                //         {
                //           "id": "ba2d29c0-af5b-422f-a9bf-8ec3759bb0fb",
                //           "title": "Poly",
                //           "type": "poly",
                //           "x": 48.92086330935252,
                //           "y": 4.06490252024242,
                //           "width": 17.841726618705046,
                //           "height": 49.90008843626927,
                //           "default_style": {
                //             "background_opacity": 0
                //           },
                //           "tooltip_style": {
                //             "background_color": "#0b2e33"
                //           },
                //           "tooltip_content": [
                //             {
                //               "type": "Heading",
                //               "text": "Designer Suit - 07",
                //               "heading": "h3",
                //               "other": {
                //                 "id": "",
                //                 "classes": "",
                //                 "css": ""
                //               },
                //               "style": {
                //                 "fontFamily": "italiana",
                //                 "fontSize": 20.8,
                //                 "lineHeight": "normal",
                //                 "color": "#ffffff",
                //                 "textAlign": "left"
                //               },
                //               "boxModel": {
                //                 "width": "auto",
                //                 "height": "auto",
                //                 "margin": {
                //                   "top": 0,
                //                   "bottom": 0,
                //                   "left": 0,
                //                   "right": 0
                //                 },
                //                 "padding": {
                //                   "top": 10,
                //                   "bottom": 10,
                //                   "left": 10,
                //                   "right": 10
                //                 }
                //               },
                //               "id": "b7b199c4-c84c-429c-b472-a5b8898b197b"
                //             },
                //             {
                //               "type": "Paragraph",
                //               "text": "Available",
                //               "other": {
                //                 "id": "",
                //                 "classes": "",
                //                 "css": ""
                //               },
                //               "style": {
                //                 "fontFamily": "barlow",
                //                 "fontSize": 26,
                //                 "lineHeight": 22,
                //                 "color": "#ad937b",
                //                 "textAlign": "left"
                //               },
                //               "boxModel": {
                //                 "width": "auto",
                //                 "height": "auto",
                //                 "margin": {
                //                   "top": 0,
                //                   "bottom": 0,
                //                   "left": 0,
                //                   "right": 0
                //                 },
                //                 "padding": {
                //                   "top": 10,
                //                   "bottom": 10,
                //                   "left": 10,
                //                   "right": 10
                //                 }
                //               },
                //               "id": "3d742eba-c724-4b34-bcd3-971a4b825f63"
                //             }
                //           ],
                //           "actions": {
                //             "click": "run-script",
                //             "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/9/7';"
                //           },
                //           "x_image_background": 48.92086330935252,
                //           "y_image_background": 4.06490252024242,
                //           "points": [
                //             {
                //               "x": 100,
                //               "y": 0.23364485981308408
                //             },
                //             {
                //               "x": 0,
                //               "y": 0
                //             },
                //             {
                //               "x": 0.4032258064516129,
                //               "y": 21.49532710280374
                //             },
                //             {
                //               "x": 42.74193548387097,
                //               "y": 21.962616822429908
                //             },
                //             {
                //               "x": 42.33870967741936,
                //               "y": 94.62616822429906
                //             },
                //             {
                //               "x": 51.20967741935484,
                //               "y": 94.85981308411215
                //             },
                //             {
                //               "x": 52.016129032258064,
                //               "y": 99.53271028037383
                //             },
                //             {
                //               "x": 69.75806451612904,
                //               "y": 100
                //             },
                //             {
                //               "x": 69.75806451612904,
                //               "y": 94.62616822429906
                //             },
                //             {
                //               "x": 100,
                //               "y": 94.62616822429906
                //             }
                //           ]
                //         },
                //         {
                //           "id": "da6a149b-e009-4e85-92ed-3243a9685951",
                //           "title": "Poly",
                //           "type": "poly",
                //           "x": 66.61870503597123,
                //           "y": 3.831724536895367,
                //           "width": 32.23021582733813,
                //           "height": 50.13326641961633,
                //           "default_style": {
                //             "background_opacity": 0
                //           },
                //           "tooltip_style": {
                //             "background_color": "#0b2e33"
                //           },
                //           "tooltip_content": [
                //             {
                //               "type": "Heading",
                //               "text": "Designer Suit - 06",
                //               "heading": "h3",
                //               "other": {
                //                 "id": "",
                //                 "classes": "",
                //                 "css": ""
                //               },
                //               "style": {
                //                 "fontFamily": "italiana",
                //                 "fontSize": 20.8,
                //                 "lineHeight": "normal",
                //                 "color": "#ffffff",
                //                 "textAlign": "left"
                //               },
                //               "boxModel": {
                //                 "width": "auto",
                //                 "height": "auto",
                //                 "margin": {
                //                   "top": 0,
                //                   "bottom": 0,
                //                   "left": 0,
                //                   "right": 0
                //                 },
                //                 "padding": {
                //                   "top": 10,
                //                   "bottom": 10,
                //                   "left": 10,
                //                   "right": 10
                //                 }
                //               },
                //               "id": "b7b199c4-c84c-429c-b472-a5b8898b197b"
                //             },
                //             {
                //               "type": "Paragraph",
                //               "text": "Available",
                //               "other": {
                //                 "id": "",
                //                 "classes": "",
                //                 "css": ""
                //               },
                //               "style": {
                //                 "fontFamily": "barlow",
                //                 "fontSize": 26,
                //                 "lineHeight": 22,
                //                 "color": "#ad937b",
                //                 "textAlign": "left"
                //               },
                //               "boxModel": {
                //                 "width": "auto",
                //                 "height": "auto",
                //                 "margin": {
                //                   "top": 0,
                //                   "bottom": 0,
                //                   "left": 0,
                //                   "right": 0
                //                 },
                //                 "padding": {
                //                   "top": 10,
                //                   "bottom": 10,
                //                   "left": 10,
                //                   "right": 10
                //                 }
                //               },
                //               "id": "3d742eba-c724-4b34-bcd3-971a4b825f63"
                //             }
                //           ],
                //           "actions": {
                //             "click": "run-script",
                //             "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/9/6';"
                //           },
                //           "x_image_background": 66.61870503597123,
                //           "y_image_background": 3.831724536895367,
                //           "points": [
                //             {
                //               "x": 100,
                //               "y": 36.74418604651163
                //             },
                //             {
                //               "x": 100,
                //               "y": 0.46511627906976744
                //             },
                //             {
                //               "x": 0,
                //               "y": 0
                //             },
                //             {
                //               "x": 0.4464285714285714,
                //               "y": 94.41860465116278
                //             },
                //             {
                //               "x": 16.964285714285715,
                //               "y": 94.65116279069767
                //             },
                //             {
                //               "x": 16.741071428571427,
                //               "y": 99.76744186046511
                //             },
                //             {
                //               "x": 27.232142857142854,
                //               "y": 100
                //             },
                //             {
                //               "x": 27.232142857142854,
                //               "y": 94.65116279069767
                //             },
                //             {
                //               "x": 31.919642857142854,
                //               "y": 94.65116279069767
                //             },
                //             {
                //               "x": 32.142857142857146,
                //               "y": 36.97674418604651
                //             }
                //           ]
                //         },
                //         {
                //           "id": "82820315-c7ec-4cbb-94ef-831eeee65f1e",
                //           "title": "Poly",
                //           "type": "poly",
                //           "x": 65.82733812949641,
                //           "y": 61.89304239031149,
                //           "width": 32.80575539568345,
                //           "height": 36.142587418793156,
                //           "default_style": {
                //             "background_opacity": 0
                //           },
                //           "tooltip_style": {
                //             "background_color": "#0b2e33"
                //           },
                //           "tooltip_content": [
                //             {
                //               "type": "Heading",
                //               "text": "Two Bedroom Penthouse - 05",
                //               "heading": "h3",
                //               "other": {
                //                 "id": "",
                //                 "classes": "",
                //                 "css": ""
                //               },
                //               "style": {
                //                 "fontFamily": "italiana",
                //                 "fontSize": 20.8,
                //                 "lineHeight": "normal",
                //                 "color": "#ffffff",
                //                 "textAlign": "left"
                //               },
                //               "boxModel": {
                //                 "width": "auto",
                //                 "height": "auto",
                //                 "margin": {
                //                   "top": 0,
                //                   "bottom": 0,
                //                   "left": 0,
                //                   "right": 0
                //                 },
                //                 "padding": {
                //                   "top": 10,
                //                   "bottom": 10,
                //                   "left": 10,
                //                   "right": 10
                //                 }
                //               },
                //               "id": "b7b199c4-c84c-429c-b472-a5b8898b197b"
                //             },
                //             {
                //               "type": "Paragraph",
                //               "text": "Available",
                //               "other": {
                //                 "id": "",
                //                 "classes": "",
                //                 "css": ""
                //               },
                //               "style": {
                //                 "fontFamily": "barlow",
                //                 "fontSize": 26,
                //                 "lineHeight": 22,
                //                 "color": "#ad937b",
                //                 "textAlign": "left"
                //               },
                //               "boxModel": {
                //                 "width": "auto",
                //                 "height": "auto",
                //                 "margin": {
                //                   "top": 0,
                //                   "bottom": 0,
                //                   "left": 0,
                //                   "right": 0
                //                 },
                //                 "padding": {
                //                   "top": 10,
                //                   "bottom": 10,
                //                   "left": 10,
                //                   "right": 10
                //                 }
                //               },
                //               "id": "3d742eba-c724-4b34-bcd3-971a4b825f63"
                //             }
                //           ],
                //           "actions": {
                //             "click": "run-script",
                //             "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/9/5';"
                //           },
                //           "x_image_background": 65.82733812949641,
                //           "y_image_background": 61.89304239031149,
                //           "points": [
                //             {
                //               "x": 0.21929824561403508,
                //               "y": 0
                //             },
                //             {
                //               "x": 0,
                //               "y": 80
                //             },
                //             {
                //               "x": 12.5,
                //               "y": 79.6774193548387
                //             },
                //             {
                //               "x": 12.719298245614036,
                //               "y": 99.35483870967742
                //             },
                //             {
                //               "x": 50.877192982456144,
                //               "y": 99.35483870967742
                //             },
                //             {
                //               "x": 50.877192982456144,
                //               "y": 80
                //             },
                //             {
                //               "x": 64.69298245614034,
                //               "y": 79.6774193548387
                //             },
                //             {
                //               "x": 64.47368421052632,
                //               "y": 100
                //             },
                //             {
                //               "x": 83.33333333333334,
                //               "y": 99.67741935483872
                //             },
                //             {
                //               "x": 83.1140350877193,
                //               "y": 80
                //             },
                //             {
                //               "x": 95.83333333333334,
                //               "y": 79.6774193548387
                //             },
                //             {
                //               "x": 95.17543859649122,
                //               "y": 33.87096774193548
                //             },
                //             {
                //               "x": 100,
                //               "y": 33.87096774193548
                //             },
                //             {
                //               "x": 100,
                //               "y": 0
                //             }
                //           ]
                //         },
                //         {
                //           "id": "ab239491-320d-47e7-828d-35fa88a4e06f",
                //           "title": "Poly",
                //           "type": "poly",
                //           "x": 34.82014388489208,
                //           "y": 62.00963138198502,
                //           "width": 31.007194244604328,
                //           "height": 36.02599842711963,
                //           "default_style": {
                //             "background_opacity": 0
                //           },
                //           "tooltip_style": {
                //             "background_color": "#0b2e33"
                //           },
                //           "tooltip_content": [
                //             {
                //               "type": "Heading",
                //               "text": "Two Bedroom Penthouse - 04",
                //               "heading": "h3",
                //               "other": {
                //                 "id": "",
                //                 "classes": "",
                //                 "css": ""
                //               },
                //               "style": {
                //                 "fontFamily": "italiana",
                //                 "fontSize": 20.8,
                //                 "lineHeight": "normal",
                //                 "color": "#ffffff",
                //                 "textAlign": "left"
                //               },
                //               "boxModel": {
                //                 "width": "auto",
                //                 "height": "auto",
                //                 "margin": {
                //                   "top": 0,
                //                   "bottom": 0,
                //                   "left": 0,
                //                   "right": 0
                //                 },
                //                 "padding": {
                //                   "top": 10,
                //                   "bottom": 10,
                //                   "left": 10,
                //                   "right": 10
                //                 }
                //               },
                //               "id": "b7b199c4-c84c-429c-b472-a5b8898b197b"
                //             },
                //             {
                //               "type": "Paragraph",
                //               "text": "Available",
                //               "other": {
                //                 "id": "",
                //                 "classes": "",
                //                 "css": ""
                //               },
                //               "style": {
                //                 "fontFamily": "barlow",
                //                 "fontSize": 26,
                //                 "lineHeight": 22,
                //                 "color": "#ad937b",
                //                 "textAlign": "left"
                //               },
                //               "boxModel": {
                //                 "width": "auto",
                //                 "height": "auto",
                //                 "margin": {
                //                   "top": 0,
                //                   "bottom": 0,
                //                   "left": 0,
                //                   "right": 0
                //                 },
                //                 "padding": {
                //                   "top": 10,
                //                   "bottom": 10,
                //                   "left": 10,
                //                   "right": 10
                //                 }
                //               },
                //               "id": "3d742eba-c724-4b34-bcd3-971a4b825f63"
                //             }
                //           ],
                //           "actions": {
                //             "click": "run-script",
                //             "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/9/4';"
                //           },
                //           "x_image_background": 34.82014388489208,
                //           "y_image_background": 62.00963138198502,
                //           "points": [
                //             {
                //               "x": 0,
                //               "y": 0
                //             },
                //             {
                //               "x": 0.23201856148491878,
                //               "y": 99.67637540453075
                //             },
                //             {
                //               "x": 20.649651972157773,
                //               "y": 99.67637540453075
                //             },
                //             {
                //               "x": 20.417633410672853,
                //               "y": 79.28802588996764
                //             },
                //             {
                //               "x": 46.8677494199536,
                //               "y": 79.6116504854369
                //             },
                //             {
                //               "x": 46.635730858468676,
                //               "y": 100
                //             },
                //             {
                //               "x": 86.77494199535964,
                //               "y": 99.67637540453075
                //             },
                //             {
                //               "x": 87.00696055684455,
                //               "y": 79.6116504854369
                //             },
                //             {
                //               "x": 100,
                //               "y": 79.28802588996764
                //             },
                //             {
                //               "x": 100,
                //               "y": 0
                //             }
                //           ]
                //         },
                //         {
                //           "id": "9f614909-4717-49dc-9b5a-7aa34c734619",
                //           "title": "Poly",
                //           "type": "poly",
                //           "x": 3.597122302158273,
                //           "y": 61.89304239031149,
                //           "width": 31.294964028776977,
                //           "height": 36.142587418793156,
                //           "default_style": {
                //             "background_opacity": 0
                //           },
                //           "tooltip_style": {
                //             "background_color": "#0b2e33"
                //           },
                //           "tooltip_content": [
                //             {
                //               "type": "Heading",
                //               "text": "Two Bedroom Penthouse - 03",
                //               "heading": "h3",
                //               "other": {
                //                 "id": "",
                //                 "classes": "",
                //                 "css": ""
                //               },
                //               "style": {
                //                 "fontFamily": "italiana",
                //                 "fontSize": 20.8,
                //                 "lineHeight": "normal",
                //                 "color": "#ffffff",
                //                 "textAlign": "left"
                //               },
                //               "boxModel": {
                //                 "width": "auto",
                //                 "height": "auto",
                //                 "margin": {
                //                   "top": 0,
                //                   "bottom": 0,
                //                   "left": 0,
                //                   "right": 0
                //                 },
                //                 "padding": {
                //                   "top": 10,
                //                   "bottom": 10,
                //                   "left": 10,
                //                   "right": 10
                //                 }
                //               },
                //               "id": "b7b199c4-c84c-429c-b472-a5b8898b197b"
                //             },
                //             {
                //               "type": "Paragraph",
                //               "text": "Available",
                //               "other": {
                //                 "id": "",
                //                 "classes": "",
                //                 "css": ""
                //               },
                //               "style": {
                //                 "fontFamily": "barlow",
                //                 "fontSize": 26,
                //                 "lineHeight": 22,
                //                 "color": "#ad937b",
                //                 "textAlign": "left"
                //               },
                //               "boxModel": {
                //                 "width": "auto",
                //                 "height": "auto",
                //                 "margin": {
                //                   "top": 0,
                //                   "bottom": 0,
                //                   "left": 0,
                //                   "right": 0
                //                 },
                //                 "padding": {
                //                   "top": 10,
                //                   "bottom": 10,
                //                   "left": 10,
                //                   "right": 10
                //                 }
                //               },
                //               "id": "3d742eba-c724-4b34-bcd3-971a4b825f63"
                //             }
                //           ],
                //           "actions": {
                //             "click": "run-script",
                //             "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/9/3';"
                //           },
                //           "x_image_background": 3.597122302158273,
                //           "y_image_background": 61.89304239031149,
                //           "points": [
                //             {
                //               "x": 0.9195402298850575,
                //               "y": 0.3225806451612903
                //             },
                //             {
                //               "x": 0,
                //               "y": 80
                //             },
                //             {
                //               "x": 13.10344827586207,
                //               "y": 80
                //             },
                //             {
                //               "x": 12.873563218390805,
                //               "y": 100
                //             },
                //             {
                //               "x": 54.02298850574713,
                //               "y": 99.35483870967742
                //             },
                //             {
                //               "x": 54.252873563218394,
                //               "y": 79.35483870967742
                //             },
                //             {
                //               "x": 79.77011494252874,
                //               "y": 79.35483870967742
                //             },
                //             {
                //               "x": 80.22988505747126,
                //               "y": 99.35483870967742
                //             },
                //             {
                //               "x": 100,
                //               "y": 99.67741935483872
                //             },
                //             {
                //               "x": 99.77011494252874,
                //               "y": 0
                //             }
                //           ]
                //         },
                //         {
                //           "id": "99596483-be74-43a3-bac4-1cdb8405baf4",
                //           "title": "Poly",
                //           "type": "poly",
                //           "x": 3.9568345323741005,
                //           "y": 3.8317233362633907,
                //           "width": 19.71223021582734,
                //           "height": 50.13326641961633,
                //           "default_style": {
                //             "background_opacity": 0
                //           },
                //           "tooltip_style": {
                //             "background_color": "#0b2e33"
                //           },
                //           "tooltip_content": [
                //             {
                //               "type": "Heading",
                //               "text": "Designer Suit - 02",
                //               "heading": "h3",
                //               "other": {
                //                 "id": "",
                //                 "classes": "",
                //                 "css": ""
                //               },
                //               "style": {
                //                 "fontFamily": "italiana",
                //                 "fontSize": 20.8,
                //                 "lineHeight": "normal",
                //                 "color": "#ffffff",
                //                 "textAlign": "left"
                //               },
                //               "boxModel": {
                //                 "width": "auto",
                //                 "height": "auto",
                //                 "margin": {
                //                   "top": 0,
                //                   "bottom": 0,
                //                   "left": 0,
                //                   "right": 0
                //                 },
                //                 "padding": {
                //                   "top": 10,
                //                   "bottom": 10,
                //                   "left": 10,
                //                   "right": 10
                //                 }
                //               },
                //               "id": "b7b199c4-c84c-429c-b472-a5b8898b197b"
                //             },
                //             {
                //               "type": "Paragraph",
                //               "text": "Available",
                //               "other": {
                //                 "id": "",
                //                 "classes": "",
                //                 "css": ""
                //               },
                //               "style": {
                //                 "fontFamily": "barlow",
                //                 "fontSize": 26,
                //                 "lineHeight": 22,
                //                 "color": "#ad937b",
                //                 "textAlign": "left"
                //               },
                //               "boxModel": {
                //                 "width": "auto",
                //                 "height": "auto",
                //                 "margin": {
                //                   "top": 0,
                //                   "bottom": 0,
                //                   "left": 0,
                //                   "right": 0
                //                 },
                //                 "padding": {
                //                   "top": 10,
                //                   "bottom": 10,
                //                   "left": 10,
                //                   "right": 10
                //                 }
                //               },
                //               "id": "3d742eba-c724-4b34-bcd3-971a4b825f63"
                //             }
                //           ],
                //           "actions": {
                //             "click": "run-script",
                //             "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/9/2';"
                //           },
                //           "x_image_background": 3.9568345323741005,
                //           "y_image_background": 3.9483135285688933,
                //           "points": [
                //             {
                //               "x": 99.63503649635037,
                //               "y": 0
                //             },
                //             {
                //               "x": 0,
                //               "y": 0
                //             },
                //             {
                //               "x": 0,
                //               "y": 27.44186046511628
                //             },
                //             {
                //               "x": 47.81021897810219,
                //               "y": 27.44186046511628
                //             },
                //             {
                //               "x": 48.54014598540146,
                //               "y": 93.95348837209302
                //             },
                //             {
                //               "x": 55.839416058394164,
                //               "y": 94.41860465116278
                //             },
                //             {
                //               "x": 55.839416058394164,
                //               "y": 100
                //             },
                //             {
                //               "x": 72.26277372262774,
                //               "y": 99.53488372093024
                //             },
                //             {
                //               "x": 72.26277372262774,
                //               "y": 94.41860465116278
                //             },
                //             {
                //               "x": 100,
                //               "y": 94.65116279069767
                //             }
                //           ]
                //         },
                //         {
                //           "id": "19c01405-2eb7-42e5-bd77-a4a440e356fe",
                //           "title": "Poly",
                //           "type": "poly",
                //           "x": 23.597122302158276,
                //           "y": 3.7151343445898646,
                //           "width": 17.985611510791365,
                //           "height": 50.0166774279428,
                //           "default_style": {
                //             "background_opacity": 0
                //           },
                //           "tooltip_style": {
                //             "background_color": "#0b2e33"
                //           },
                //           "tooltip_content": [
                //             {
                //               "type": "Heading",
                //               "text": "Designer Suit - 01",
                //               "heading": "h3",
                //               "other": {
                //                 "id": "",
                //                 "classes": "",
                //                 "css": ""
                //               },
                //               "style": {
                //                 "fontFamily": "italiana",
                //                 "fontSize": 20.8,
                //                 "lineHeight": "normal",
                //                 "color": "#ffffff",
                //                 "textAlign": "left"
                //               },
                //               "boxModel": {
                //                 "width": "auto",
                //                 "height": "auto",
                //                 "margin": {
                //                   "top": 0,
                //                   "bottom": 0,
                //                   "left": 0,
                //                   "right": 0
                //                 },
                //                 "padding": {
                //                   "top": 10,
                //                   "bottom": 10,
                //                   "left": 10,
                //                   "right": 10
                //                 }
                //               },
                //               "id": "b7b199c4-c84c-429c-b472-a5b8898b197b"
                //             },
                //             {
                //               "type": "Paragraph",
                //               "text": "Available",
                //               "other": {
                //                 "id": "",
                //                 "classes": "",
                //                 "css": ""
                //               },
                //               "style": {
                //                 "fontFamily": "barlow",
                //                 "fontSize": 26,
                //                 "lineHeight": 22,
                //                 "color": "#ad937b",
                //                 "textAlign": "left"
                //               },
                //               "boxModel": {
                //                 "width": "auto",
                //                 "height": "auto",
                //                 "margin": {
                //                   "top": 0,
                //                   "bottom": 0,
                //                   "left": 0,
                //                   "right": 0
                //                 },
                //                 "padding": {
                //                   "top": 10,
                //                   "bottom": 10,
                //                   "left": 10,
                //                   "right": 10
                //                 }
                //               },
                //               "id": "3d742eba-c724-4b34-bcd3-971a4b825f63"
                //             }
                //           ],
                //           "actions": {
                //             "click": "run-script",
                //             "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/9/1';"
                //           },
                //           "x_image_background": 23.597122302158276,
                //           "y_image_background": 3.831724536895367,
                //           "points": [
                //             {
                //               "x": 99.2,
                //               "y": 21.678321678321677
                //             },
                //             {
                //               "x": 100,
                //               "y": 0
                //             },
                //             {
                //               "x": 0,
                //               "y": 0.2331002331002331
                //             },
                //             {
                //               "x": 0.4,
                //               "y": 94.87179487179486
                //             },
                //             {
                //               "x": 30,
                //               "y": 94.87179487179486
                //             },
                //             {
                //               "x": 30,
                //               "y": 100
                //             },
                //             {
                //               "x": 48.4,
                //               "y": 100
                //             },
                //             {
                //               "x": 47.599999999999994,
                //               "y": 94.63869463869464
                //             },
                //             {
                //               "x": 57.199999999999996,
                //               "y": 94.87179487179486
                //             },
                //             {
                //               "x": 56.8,
                //               "y": 21.91142191142191
                //             }
                //           ]
                //         }
                //       ]
                //     }
                //   ],
                //   "version": "6.0.20"
                // });
            }
        };

        // Wait for the script to load
        const script = document.createElement('script');
        script.src = '/js/image-map-pro.min.js';
        script.onload = initializeImageMap;
        document.head.appendChild(script);
    }, []);

    return (
        // <div>
        //     <div id="image-map-pro"></div>
        // </div>
        <div justifyContent="center" alignItems="center">
          {/* Responsive container for the image map */}
          <div width={{ base: '100%', md: '80%' }} height={{ base: '300px', md: '400px' }} position="relative">
            {/* Ensure the image map fills its parent container */}
            <div id="image-map-pro" height="100%" width="100%"></div>
          </div>
        </div>
    );
}

export default Floor9Component;
